import { useEffect, useState } from "react";

/**
 * 오프라인/연결 끊김 안내 배너(FR-COM).
 *
 * 왜: 지금까지 화면마다 실패 처리가 제각각이라, 네트워크가 끊기면 어떤 화면은 침묵하고
 * 어떤 화면은 로딩만 돌았다. 앱 전역에서 한 줄로 정직하게 알린다.
 * 무엇을 약속하나: M1은 정적이라 **이미 열린 화면은 계속 볼 수 있다**(불변식 3) — 그걸 안내한다.
 * 시각안전: 등장 애니 없음·플래시 없음. 스크린리더에는 role="status"(방해 없이 알림).
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(() =>
    typeof navigator !== "undefined" ? navigator.onLine === false : false,
  );

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div className="offline-banner" role="status">
      <span aria-hidden="true">🌙</span>
      지금은 인터넷 연결이 어려워요. <b>한 번 본 그림책은 계속 볼 수 있어요.</b>
    </div>
  );
}
